import { DrawerTypes } from 'FileManagerLib/Constants';
import { INSERT_LINK_TO_FILE } from '../constants/usageTracking';
import { trackInteraction } from './usageTracking';
import { openFileManager } from './fileManager';
const getInsertHandler = (editor, callback) => file => {
  callback(file);
  editor.focus();
  trackInteraction(editor, 'tinymceEdit', INSERT_LINK_TO_FILE);
};
export function getOpenFilePicker(editor) {
  return insertFileCallback => {
    const onInsertFile = getInsertHandler(editor, insertFileCallback);
    openFileManager(editor, DrawerTypes.FILE, onInsertFile);
  };
}